<template>
  <div class="record">

    <div class="header">
      <peopleHeader></peopleHeader>
    </div>

    <div class="content">
      <!-- <div class="message">
        <VShowCell typeIcon="A" title="我的信息" :recordModel="record">
          <p class="two" v-text="record.message.label"></p>
          <p class="two" v-text="record.message.message"></p>
        </VShowCell>
      </div> -->

      <!-- s -->

      <div class="aboutCourse">
        <VShowCell typeIcon="C" title="课程相关">
          <!-- <p class="two" v-text="record.course_item_order.total_courses"></p>
          <p class="two" v-text="record.course_item_order.presented_course"></p> -->
        </VShowCell>
      </div>
      <div class="completeCourse">
        <VShowCell typeIcon="D" title="已上课程">
          <!-- <p class="one" v-text="record.above_course.label"></p> -->
        </VShowCell>
      </div>

      <!-- <div class="photo">
        <VShowCell typeIcon="E" title="我的照片" :recordModel="record">
          <div class="photo" v-for="obj,index in record.my_photos" :key="index">
            <img class="photoimg" :src="obj.image_original" alt="">
          </div>
        </VShowCell>
      </div> -->

    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import peopleHeader from '../components/peopleHeader';
  import VShowCell from '../components/VShowCell';
  import Record from '../api/record.js';
  import { mapGetters } from 'vuex';
  export default{
    name: 'myRecord',
    data() {
      return {
        // record: {
        //   teacher_said: {},
        //   course_item_order: {},
        //   above_course: {},
        //   my_photos: {}
        // }
      };
    },
    // created() {
    //   this.recorde();
    // },
    methods: {
      // recorde () {
      //   console.log(this.user.user_role.user_type,"//")
      //   let schoolId = 0;
      //   let gradeId = 0;
      //   if (this.user.user_role.user_type === "1") {
      //     schoolId = this.user.user_role.school_id;
      //     gradeId = this.user.user_role.grade_id;
      //   } else {
      //     schoolId = this.school.school_id;
      //     gradeId = this.grade.grade_id;
      //   }
      //   let params = {
      //     school_id: schoolId,
      //     grade_id: gradeId
      //   };
//         Record.Record().then((response) => {
//           if (response.errno === '0') {
//             this.record = response.result;
//           } else {
//             alert(response.message);
//           }
//         })
//           .catch((e) => {
// //          console.log(error);
//           });
      // }
    },
    components: {peopleHeader, VShowCell},
    computed: {
      ...mapGetters({
        user: 'getUserInfo',
        school: 'school',
        grade: 'grade'
      })
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .record {
    @include bg-img('../assets/img/common/parentbgbase');
    position: relative;
    left: px2rem(27);
    right: px2rem(27);
    width: px2rem(704);
    top: px2rem(128);
    height: px2rem(1004);
  }

  .header {
    top: px2rem(-50);
  }

  .two {
    line-height: px2rem(41);
    font-size: px2rem(23);
    color: rgba(123, 74, 0, 1);
  }

  .one {
    font-size: px2rem(23);
    color: rgba(123, 74, 0, 1);
    white-space: normal;
    width: 100%;
    line-height: px2rem(41);

  }

  .photo {
    display: inline-block;
    padding-top: px2rem(5);
    margin-right: px2rem(5);
  }

  .photoimg {
    width: px2rem(78);
    height: px2rem(78);
  }


</style>



// WEBPACK FOOTER //
// MyRecord.vue?78b11eee